import { render, staticRenderFns } from "./AddGroups.vue?vue&type=template&id=1c18a1ee&scoped=true"
import script from "./AddGroups.vue?vue&type=script&lang=js"
export * from "./AddGroups.vue?vue&type=script&lang=js"
import style0 from "./AddGroups.vue?vue&type=style&index=0&id=1c18a1ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c18a1ee",
  null
  
)

export default component.exports